export default "__VITE_ASSET__94d6752b__"